import { configureStore } from "@reduxjs/toolkit";
import memberReducer from "./member/memberReducer";
export const store = configureStore({
  reducer: {
    member: memberReducer,
  },
});
